<template>
  <form-wrapper :title="option.title"
                :description="option.description"
                @submit="submit()"
                @previous="previous()"
                :isFirst="isFirst"
                :isLast="isLast"
                :disabled="isSaving">
    
      <b-form-group label="Address(es)"
                    label-class="control-label" :class="{ 'invalid-group': $v.form.otherAddress.$error }">
        <b-form-textarea 
                  v-model="form.otherAddress"
                  placeholder="Enter an address"
                  :rows="3"
                  :max-rows="6"
                  :class="{ 'is-invalid': $v.form.otherAddress.$error }"
                  >
        </b-form-textarea>
        <span class="span-feedback invalid-feedback" v-if="$v.form.otherAddress.$error">You must enter address information.</span>
      </b-form-group>   

      <b-form-group label="Is this a paid position?" label-class="control-label" :class="{ 'invalid-group': $v.form.isPaid.$error }">
        <b-form-select :class="{ 'is-invalid': $v.form.isPaid.$error }"
                        v-model="form.isPaid"
                        :options="options"
                        value-field="value"
                        text-field="text">
          <template slot="first">
            <option value=""></option>
          </template>
        </b-form-select>
        <span class="span-feedback invalid-feedback" v-if="$v.form.isPaid.$error">You must indicate if this is a paid position.</span>
      </b-form-group>

      <b-form-group label="Are you currently employed at this site?" label-class="control-label" :class="{ 'invalid-group': $v.form.isCurrentEmployee.$error }">
        <b-form-select :class="{ 'is-invalid': $v.form.isCurrentEmployee.$error }"
                        v-model="form.isCurrentEmployee"
                        :options="options"
                        value-field="value"
                        text-field="text">
          <template slot="first">
            <option value=""></option>
          </template>
        </b-form-select>
        <span class="span-feedback invalid-feedback" v-if="$v.form.isCurrentEmployee.$error">You must indicate if this is a paid position.</span>
      </b-form-group>

      <b-form-group label="What will your job title be?" label-class="control-label" :class="{ 'invalid-group': $v.form.jobTitle.$error }">
        <b-form-input v-model="form.jobTitle" :class="{ 'is-invalid': $v.form.jobTitle.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.jobTitle.$error">You must enter a job title.</span>
      </b-form-group>
    
  </form-wrapper>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import formWrapper from "./form-wrapper";

export default {
  data() {
    return {
      form: {
        otherAddress: "",
        isPaid: null,
        isCurrentEmployee: null,
        jobTitle: "",
        studentOpportunityId: 0
      },
      options: [{ value: false, text: "No" }, { value: true, text: "Yes" }],
      isSaving: false
    };
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    "form-wrapper": formWrapper
  },

  validations: {
    form: {
      otherAddress: { required },
      isPaid: { required },
      isCurrentEmployee: { required },
      jobTitle: {},
      studentOpportunityId: {}
    }
  },

  computed: {
    ...mapState({
      userId: state => state.auth.user.userId,
      studentOpportunityId: state =>
        state.additionalMaterials.studentOpportunityId,
      studentOpportunity: state => state.additionalMaterials.studentOpportunity
    })
  },

  methods: {
    ...mapActions("placements", ["postUpdateJobDetails"]),
    handleInput: function() {
      this.returnItem();
    },
    validate: function() {
      this.$v.$touch();
      this.returnItem();
    },
    returnItem: function() {
      this.$emit("input", this.form);
    },
    isInvalid: function() {
      return this.$v.$invalid;
    },
    previous: function() {
      this.$emit("previous");
    },
    submit: function() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isSaving = true;
        this.postUpdateJobDetails({
          studentOpportunity: this.form,
          asuriteId: this.userId
        })
          .then(response => {
            if (response) {
              this.$emit("submitted");
            }
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    }
  },

  watch: {
    studentOpportunity: {
      handler: function() {
        if (this.studentOpportunity) {
          this.form = this.studentOpportunity;
        }
      },
      deep: true
    }
  },

  created() {
    if (this.studentOpportunity) {
      this.form = this.studentOpportunity;
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
